export default __webpack_public_path__ + "static/media/react-js-hooks.c1d6cbf2.jpg";